var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('Usuario',{attrs:{"area":_vm.area},on:{"update":_vm.obtener_area}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row my-2"},[_c('h1',{staticClass:"col-sm-12 text-right"},[_vm._v("Usuarios")])])
}]

export { render, staticRenderFns }